<template>
  <div class="web-to-app-download-app-mobile-gender osk-pa-md">
    <img
      class="web-to-app-download-app-mobile-gender__img"
      src="~/assets/img/webToApp/download-app-mobile-gender.png"
      srcset="~/assets/img/webToApp/download-app-mobile-gender.png, ~/assets/img/webToApp/download-app-mobile-gender-2x.png 2x"
      alt="iphone"
    >

    <div class="web-to-app-download-app-mobile-gender__content">
      <div class="text-caption text-bold">
        {{ $t('webToApp.downloadAppMobileGender.title', { sale }) }}
      </div>

      <div class="text-small osk-mt-xs">
        {{ $t('webToApp.downloadAppMobileGender.text', { promoCode }) }}
      </div>

      <UikitButton
        class="osk-mt-cp"
        size="s"
        outline
        target="_blank"
        :to="appLink"
      >
        {{ $t('webToApp.downloadAppMobileGender.downloadBtnText') }}
      </UikitButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  appLink: string
}>();

const { sale, promoCode } = useWebToApp();
</script>

<style lang="scss">
.web-to-app-download-app-mobile-gender {
  display: flex;
  justify-content: flex-end;
  background: linear-gradient(88.28deg, #BFB7AB -1.29%, #BAA58B 98.56%);
  border-radius: 2px;
  position: relative;

  &__img {
    position: absolute;
    bottom:0;
    left: 0;
  }

  &__content {
    width: 170px;
  }
}
</style>
